<template>
  <md-dialog
    v-if="toggle.userExamDocument && !toggle.covax"
    id="DocumentUploadModal"
    ref="DocumentUploadModal"
    md-title
    :md-esc-to-close="false"
    :md-click-outside-to-close="false"
    class="document-modal modal-layout modals modal-alert"
  >
    <md-dialog-title>
      <h1>
        <span class="title">Anexar documentos obrigatórios:</span>
      </h1>
      <div class="main-header-container">
        <div class="main-header-item">
          Exame
          <div class="main-header-item__field">
            <md-tooltip md-direction="top">
              {{ examInfo.name }}
            </md-tooltip>
            {{ examInfo.name }}
          </div>
        </div>
      </div>
      <button
        id="mod_btnClose"
        class="close-button btn-transparent"
        @click="setDocumentUploadModalVisible(false)"
      >
        <md-icon>clear</md-icon>
      </button>
    </md-dialog-title>
    <md-dialog-content>
      <template v-if="showDocuments">
        <div
          v-for="(document, docIndex) in examInfo.documentExamsRequired"
          :key="document.id_document_template_exam"
          class="gray-part"
        >
          <div class="header-box">
            <div class="document-title">
              <svg-loader src="/static/images/icon-document-file.svg" />
              {{ document.fileName }}
            </div>
            <div
              v-if="!document.actionsLoading"
              class="actions"
            >
              <div class="actions__show">
                <svg-loader
                  v-if="document.documentExamUpload"
                  src="/static/images/icon-show-details.svg"
                  @click.native="
                    downloadUploadedFile(document.documentExamUpload[0].id_document_exam_upload, docIndex)
                  "
                />
                <md-tooltip md-direction="top">
                  Visualizar documento anexado.
                </md-tooltip>
              </div>
              <div class="actions__delete">
                <svg-loader
                  v-if="document.documentExamUpload"
                  src="/static/images/icon-edit-alt.svg"
                  @click.native="
                    deleteDocumentUploaded(document.documentExamUpload[0].id_document_exam_upload, docIndex)
                  "
                />
                <md-tooltip md-direction="top">
                  Alterar documento anexado.
                </md-tooltip>
              </div>
            </div>
            <div v-else>
              <spinner />
            </div>
          </div>
          <div class="cards-container">
            <button-modal
              v-for="(btn, btnIndex) in buttons"
              :ref="'buttonTrigger-' + docIndex"
              :key="btnIndex"
              :button-data="btn"
              :file-info="document"
              :exam-info="examInfo"
              :doc-index="docIndex"
              @uploadFinished="updateFileUploaded"
              @download-document="downloadDocument"
            />
          </div>
        </div>
      </template>
      <div v-else>
        <loading />
      </div>
    </md-dialog-content>
  </md-dialog>
</template>
<script>
import ButtonModal from './Button'
import { mapActions, mapGetters } from 'vuex'
import { DOCUMENT_INFO, eventBus } from '@/api/eventbus'
import notify from '@/api/notification'
import Spinner from '@/components/common/Spinner'
import documentManagementService from '@/api/documentManagement'
import { convertBase64ToFile } from '@/utils/convertBase64ToFile'
export default {
  name: 'DocumentModal',
  components: {
    'button-modal': ButtonModal,
    spinner: Spinner
  },
  data: () => {
    return {
      showDocuments: true,
      examInfo: {
        name: null,
        id: null,
        osNumber: null,
        documentExamsRequired: []
      },
      buttons: [
        {
          title: '1',
          titleBackgroundColor: 'orange',
          subtitle: 'Baixar o documento',
          subtitleBackgroundColor: 'orange',
          boxSeparated: true,
          action: 'download',
          disabled: false
        },
        {
          title: '2',
          titleBackgroundColor: 'orange',
          subtitle: 'Preencha e digitalize o documento baixado',
          subtitleBackgroundColor: 'white',
          boxSeparated: true,
          disabled: true,
          action: ''
        },
        {
          title: '3',
          titleBackgroundColor: 'green',
          subtitle: 'Documento anexado',
          subtitleBackgroundColor: 'green',
          boxSeparated: true,
          disabled: false,
          action: 'upload'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['profile', 'isDocumentUploadModalVisible', 'toggle'])
  },
  watch: {
    isDocumentUploadModalVisible(newValue) {
      if (newValue) {
        this.$refs.DocumentUploadModal.open()
        this.$analytics.pushAnalyticsEvent('vpageview', {
          page: '/modal/attach-documents-pending',
          'id-user': this.profile.id,
          'id-lab': this.profile.id_laboratory,
          'name-lab': this.profile.laboratoryName
        })
      } else {
        this.$refs.DocumentUploadModal.close()
      }
    },
    examInfo() {
      this.reloadDocuments()
    }
  },
  created() {
    let self = this
    eventBus.$on(DOCUMENT_INFO, function (examInfo) {
      self.examInfo = examInfo
    })
  },
  methods: {
    ...mapActions(['setDocumentUploadModalVisible', 'uploadDownloadFileUploaded']),
    reloadDocuments() {
      this.showDocuments = false
      this.$nextTick(() => {
        this.showDocuments = true
      })
    },
    downloadDocument(document) {
      notify({
        title: 'AVISO:',
        message: 'Fazendo download...'
      })
      documentManagementService
        .downloadDocumentByUuid(document.documentTemplateUuid)
        .then(response => {
          let fileName = document.fileName
          let fileExtension = fileName.split('.')[1]
          convertBase64ToFile({
            file: response,
            fileName: fileName,
            fileExtension: fileExtension
          })
          notify({
            title: 'AVISO:',
            message: 'Download realizado com sucesso.'
          })
        })
        .catch(() => {
          notify({
            title: 'AVISO:',
            message: 'Não foi possível fazer download do documento.'
          })
        })
    },
    updateFileUploaded({ docIndex, fileInfoUpdated }) {
      this.examInfo.documentExamsRequired[docIndex].documentExamUpload = fileInfoUpdated
    },
    downloadUploadedFile(fileId, docIndex) {
      this.setLoadingStatusForActions({ index: docIndex, loading: true })
      this.uploadDownloadFileUploaded(fileId)
        .then(() => {
          this.setLoadingStatusForActions({ index: docIndex, loading: false })
        })
        .catch(() => {
          this.setLoadingStatusForActions({ index: docIndex, loading: false })
        })
    },
    deleteDocumentUploaded(idExam, docIndex) {
      this.resetDocumentUploaded(docIndex)
    },
    setLoadingStatusForActions({ index, loading }) {
      this.examInfo.documentExamsRequired[index].actionsLoading = loading
      this.reloadDocuments()
    },
    resetDocumentUploaded(docIndex) {
      this.examInfo.documentExamsRequired[docIndex].actionsLoading = false
      this.examInfo.documentExamsRequired[docIndex].documentExamUpload = null
      this.reloadDocuments()

      setTimeout(() => {
        const buttons = this.$refs[`buttonTrigger-${docIndex}`]
        if (buttons && buttons.length > 0) {
          const lastButton = buttons[buttons.length - 1]
          lastButton.triggerClick()
        } else {
          console.error('Label não encontrada. Verifique se ela está sendo renderizada corretamente.')
        }
      }, 300)
    },
    inputLoadingInItems() {
      let docsArray = this.examInfo.documentExamsRequired
      docsArray.map(item => {
        item.actionsLoading = false
        return item
      })
    }
  }
}
</script>
<style lang="scss">
  .document-modal.modals .md-dialog {
    height: auto;
    width: 950px;
    border-radius: 5px;
    background-color: #ffffff;
    line-height: 25px;
    max-width: 95%;
    z-index: 2147483647;
    text-transform: uppercase;
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      /* IE10 & IE11 CSS styles go here */
      overflow: scroll;
      height: auto;
      -ms-overflow-style: -ms-autohiding-scrollbar;
    }
    .md-dialog-title {
      margin-bottom: 0;
      h1 {
        width: 97%;
        word-break: break-word;
        font-weight: 500;
        font-family: Roboto, sans-serif;
        font-style: normal;
        font-size: 18px;
        line-height: 21px;
        .title {
          color: #fd8f00;
          margin-right: 5px;
          word-break: break-word;
          font-weight: 500;
          font-family: Roboto, sans-serif;
          font-style: normal;
          font-size: 18px;
          line-height: 21px;
        }
      }
    }
    .title {
      min-height: 3em;
    }
    .subtitle {
      min-height: 6.6em;
      margin: 5px 0 16px 0;
      word-break: break-word;
    }
    .md-dialog-content {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
    }
    .gray-part {
      background-color: #ebebeb;
      border-radius: 5px;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: center;
      padding: 8px;
      margin-bottom: 15px;
      .header-box {
        width: 100%;
        display: flex;
        align-items: center;
        padding: 8px;
        .loader {
          height: 12px;
          width: 12px;
          margin-right: 10px;
        }
        .document-title {
          flex-grow: 2;
          align-content: flex-start;
          font-family: Roboto, sans-serif;
          font-style: normal;
          font-weight: normal;
          font-size: 13px;
          color: #4a4a4a;
          .md-icon {
            margin-right: 10px;
          }
        }
        .actions {
          display: flex;
          align-content: center;
          div {
            margin-left: 11px;
          }
          &__show {
            svg {
              cursor: pointer;
              width: 20px;
              padding-top: 5px;
            }
          }
          &__delete {
            svg {
              cursor: pointer;
              width: 17px;
              height: 16px;
              margin-top: 4px;

              path {
                fill: #828282;
              }
            }
          }
        }
      }
    }
    .cards-container {
      display: flex;
      width: 100%;
    }
    .main-header {
      &-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 20px;
        font-size: 12px;
        word-break: break-word;
        font-style: normal;
        line-height: 26px;
        font-weight: 500;
        font-family: Roboto, sans-serif;
        text-transform: uppercase;
      }
      &-item {
        display: flex;
        flex-direction: column;
        width: 100%;
        &__field {
          overflow: hidden;
          width: 100%;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 16px;
          word-break: break-word;
          font-style: normal;
          line-height: 22px;
          font-weight: 600;
          font-family: Roboto, sans-serif;
          text-transform: uppercase;
        }
      }
    }
  }
  .tooltip-small {
    margin-right: 200px;
    text-align: left;
  }
</style>
